import { render, staticRenderFns } from "./TrendsAndInsights.vue?vue&type=template&id=5489474d&"
import script from "./TrendsAndInsights.vue?vue&type=script&lang=js&"
export * from "./TrendsAndInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports